import React from 'react';

import { colorsPalette } from '../../theme';

const CircleMinusIcon = (props) => {
  const color = props?.color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
      <path
        d="M7.55355 6.33252H6.22021H3.55355V7.66585H6.22021H7.55355H10.2202V6.33252H7.55355ZM6.88688 0.33252C3.20688 0.33252 0.220215 3.31919 0.220215 6.99919C0.220215 10.6792 3.20688 13.6659 6.88688 13.6659C10.5669 13.6659 13.5535 10.6792 13.5535 6.99919C13.5535 3.31919 10.5669 0.33252 6.88688 0.33252ZM6.88688 12.3325C3.94688 12.3325 1.55355 9.93919 1.55355 6.99919C1.55355 4.05919 3.94688 1.66585 6.88688 1.66585C9.82688 1.66585 12.2202 4.05919 12.2202 6.99919C12.2202 9.93919 9.82688 12.3325 6.88688 12.3325Z"
        fill={color ? color : colorsPalette.white}
      />
    </svg>
  );
};

export default CircleMinusIcon;
